import querystring from 'querystring';
import {isString} from 'lodash';
import api from './BaseApi';

class BaseService {
  api = api

  get(id, prefix = this.prefix) {
    if (id) {
      return api.get(`${prefix}/${id}`);
    }
    return api.get(prefix);
  }

  post(body, prefix = this.prefix) {
    return api.post(prefix, body);
  }

  search(params = {}, prefix = this.prefix, options) {
    const query = isString(params) ? params : querystring.stringify(params);
    return api.get(`${prefix}?${query}`, options);
  }

  update(entity, prefix = this.prefix) {
    return api.put(`${prefix}/${entity.id}`, entity);
  }

  remove(id, prefix = this.prefix) {
    return api.remove((id) ? `${prefix}/${id}` : `${prefix}`);
  }
}

export default BaseService;
